import {useSettingsQuery} from '../../../common/providers/ApiInterface'

export const useUpmPlantDetails = (upmPlantId?: string) => {
  return useSettingsQuery('plantDetails', [upmPlantId], {
    gcTime: 0,
    retry: false,
    staleTime: 0,
    enabled: !!upmPlantId
  })
}

export const QueryKey = 'plantDetails'
